import { I18N } from 'aurelia-i18n';
import { StringHelper } from '../../../../helpers/string-helper';
import { AccountPaymentItem } from '../../../../models/account-payment-item';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class MeetsPortfolioMinAmountRule implements IValidationRule {
	constructor(private i18n: I18N, private items: AccountPaymentItem[]) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();

		// enforce portfolio-level min payment on total payment. If multiple portfolios selected, it should use the max of the min (most restrictive).
		let min: number = -1;

		let totalAmount: number = 0;

		this.items.forEach((i: AccountPaymentItem) => {
			if (i.isSelected) {
				if (i.paymentLimitSettings.minimumPaymentAmount != null &&
					i.paymentLimitSettings.minimumPaymentAmount !== 0 &&
					i.paymentLimitSettings.minimumPaymentAmount > min) {
					min = i.paymentLimitSettings.minimumPaymentAmount;
				}
				let parsedAmount: number = parseFloat(i.enteredAmount);
				if (!isNaN(parsedAmount)) {
					totalAmount += parsedAmount;
				}
			}
		});

		result.isValid = (totalAmount >= min);

		if (!result.isValid) {
			result.errorMessage = this.i18n.i18next.t('totalPaymentDoesNotMeetMinLimits', {
				defaultValue: 'Total payment must be at least ' + StringHelper.formatCurrency(min) + '.',
				minPayment: StringHelper.formatCurrency(min),
			});
		}

		return result;
	}
}
